// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7c054893","963":"9fc877bc"}[chunkId] + ".chunk.js";
};